import React, { Fragment, useCallback } from "react";
import _ from "lodash";

import { Table } from "../../../../components/table/Table";
import { initialSort, SEARCH_KEYS } from "./DrilldownTable.constants";
import {
  MOBILE_COLUMNS,
  MOBILE_SUBROWS,
  MOBILE_HIDDEN_COLUMNS,
} from "./DrilldownMobileTable.constants";
import { DrilldownTableHeader } from "../drilldownTableHeader";
import { useIntlTranslate } from "../../../../hooks";
import { showValue } from "../../../../components/table/helpers";

export const DrilldownTableMobile = ({
  page,
  data,
  isLoading,
  dataFailure,
  onRefreshClick,
}) => {
  const translate = useIntlTranslate();
  const caption = translate(`aria_table_caption_drilldown_${page}`);
  const tableName = translate(`aria_table_name_drilldown_${page}`);

  const columns = MOBILE_COLUMNS[page];
  const subRowItems = MOBILE_SUBROWS[page];

  const renderRowSubComponent = useCallback(
    ({ row }) => (
      <div className={"sub-row-content"}>
        {_.map(subRowItems, (item) => (
          <Fragment key={item.accessor}>
            <div className={"sub-row-content__header"}>{item.header}</div>
            <div className="sub-row-content__data">
              {showValue(_.get(row.original, item.accessor))}
            </div>
          </Fragment>
        ))}
      </div>
    ),
    [subRowItems]
  );

  return (
    <Table
      header={<DrilldownTableHeader page={page} />}
      columns={columns}
      data={data}
      defaultSorted={[initialSort]}
      hiddenColumns={MOBILE_HIDDEN_COLUMNS[page]}
      renderRowSubComponent={renderRowSubComponent}
      searchKeys={SEARCH_KEYS}
      showPagination={!isLoading}
      visibleHeader={false}
      searchAriaLabelMessage="aria_search_for_drilldown_item"
      caption={caption}
      tableName={tableName}
      isLoading={isLoading}
      dataFailure={dataFailure}
      onRefreshClick={onRefreshClick}
    />
  );
};
